export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1000;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
};

export const handleFileChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  onFileChange: (file: File | null) => void,
): void => {
  if (event.target.files && event.target.files.length > 0) {
    onFileChange(event.target.files[0]);
  }
};

export const handleFileDrop = (
  event: React.DragEvent,
  onFileChange: (file: File | null) => void,
): void => {
  event.preventDefault();
  event.currentTarget.classList.remove("tw-border-[#146C94]");

  const droppedFile = event.dataTransfer.files?.[0];
  if (droppedFile) {
    onFileChange(droppedFile);
  }
};

export const handleCancelUpload = (
  onFileChange: (file: File | null) => void,
): void => {
  onFileChange(null);
};
